import { render, staticRenderFns } from "./Cashbox.vue?vue&type=template&id=3b64edc6&scoped=true"
import script from "./Cashbox.vue?vue&type=script&lang=js"
export * from "./Cashbox.vue?vue&type=script&lang=js"
import style0 from "./Cashbox.vue?vue&type=style&index=0&id=3b64edc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64edc6",
  null
  
)

export default component.exports